module.exports = require("core-js-pure/stable/object/get-own-property-descriptor");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor.js
// module id = 526
// module chunks = 0 1